import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { TextField, Button, Typography, Box, Alert, Link } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import { registration } from '../services/api';

const MIN_PASSWORD_LENGTH = 8;

// The page of the reset link from the email: a new password.
const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < MIN_PASSWORD_LENGTH) return setError(`Пароль должен быть не короче ${MIN_PASSWORD_LENGTH} символов`);
    if (password !== confirm) return setError('Пароли не совпадают');
    setLoading(true);
    try {
      await registration.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сменить пароль');
    }
    setLoading(false);
  };

  return (
    <AuthLayout subtitle="Новый пароль">
      {done ? (
        <Alert severity="success" sx={{ borderRadius: '12px' }}>Пароль изменён. Войдите с новым паролем.</Alert>
      ) : !token ? (
        <Alert severity="error" sx={{ borderRadius: '12px' }}>Ссылка неполная. Запросите новую на странице восстановления доступа.</Alert>
      ) : (
        <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {error && (
            <Alert severity="error" sx={{ borderRadius: '12px' }}>
              {error}{' '}
              <Link component={RouterLink} to="/forgot-password" sx={{ fontWeight: 600 }}>Запросить новую ссылку</Link>
            </Alert>
          )}
          <TextField required fullWidth label="Новый пароль" type="password" autoComplete="new-password" autoFocus
            helperText={`Не короче ${MIN_PASSWORD_LENGTH} символов`} value={password} onChange={(e) => setPassword(e.target.value)} />
          <TextField required fullWidth label="Повторите пароль" type="password" autoComplete="new-password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <Button type="submit" fullWidth variant="contained" size="large" disabled={loading}
            sx={{ py: 1.5, fontSize: '1rem', fontWeight: 700, borderRadius: '14px', background: 'linear-gradient(135deg, #19C6C0 0%, #11BDB6 100%)' }}>
            {loading ? 'Сохранение...' : 'Сохранить пароль'}
          </Button>
        </Box>
      )}
      <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '0.875rem' }}>
        <Link component={RouterLink} to="/login" sx={{ fontWeight: 600, color: '#11BDB6' }}>Перейти ко входу</Link>
      </Typography>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
